import redirectPermanently from '@/components/Redirect/redirectPermanently';

const PrivacyPolicies = () => redirectPermanently('/legal/privacidad');

export default PrivacyPolicies;
